<template>
  <div class="dashboard">
    <div class="contain">
      <p class="hello" v-if="user.start">Hello {{ user.start.full_name }},</p>
      <h1>Your Application Progress</h1>

      <div class="steps">
        <div class="step">
          <p class="title"><span>01.</span> Application Approval</p>
          <template
            v-if="
              user.phase == 'Application Approval' && !user.application_approval
            "
          >
            <div class="progress-bar">
              <div
                class="progress"
                :style="{ width: user.progress + '%' }"
              ></div>
            </div>
            <div class="progress-label" :style="{ width: user.progress + '%' }">
              <p>{{ user.progress }}%</p>
            </div>
          </template>
          <p>
            Here we'll gather your basic information so we can determine if your
            a right fit for an Equfi loan.
          </p>

          <div class="complete" v-if="user.application_approval == 'approved'">
            <img src="@/assets/img/tick.svg" />
          </div>

          <div class="btns right">
            <button
              v-if="!user.application_approval"
              @click="goTo('/application')"
              class="btn"
            >
              Continue
            </button>
            <div
              class="btn-text"
              v-if="
                user.application_approval == 'review' &&
                  user.application_approval != 'reviewSoftUnderwriting'
              "
            >
              <button class="btn text-btn">Application under review...</button>
              <p>You will be notified when your application is approved.</p>
            </div>
          </div>
        </div>

        <div class="step">
          <div
            :class="{
              on: user.application_approval != 'approved',
            }"
          ></div>
          <p class="title"><span>02.</span> Soft Underwriting</p>

          <template
            v-if="user.phase == 'Soft Underwriting' && !user.soft_underwriting"
          >
            <div class="progress-bar">
              <div class="progress" :style="{ width: progress + '%' }"></div>
            </div>
            <div class="progress-label" :style="{ width: progress + '%' }">
              <p>{{ progress }}%</p>
            </div>
          </template>

          <p>
            Here we'll gather your basic information so we can determine if
            you're a right fit for an Equfi loan.
          </p>

          <div class="complete" v-if="user.soft_underwriting == 'approved'">
            <img src="@/assets/img/tick.svg" />
          </div>

          <div
            class="btn-text"
            v-if="
              user.phase == 'Soft Underwriting' &&
                user.soft_underwriting == 'review'
            "
          >
            <button class="btn text-btn">Documents under review...</button>
            <p>You will be notified when your documents are approved.</p>
          </div>

          <div
            class="btns right"
            v-if="!user.soft_underwriting && user.phase == 'Soft Underwriting'"
          >
            <button @click="startSoftUnderwriting()" class="btn">
              {{
                $store.state.application_approval_step > 1
                  ? "Continue"
                  : "Get Started"
              }}
            </button>
          </div>
        </div>

        <div class="step">
          <div
            :class="{
              on: user.soft_underwriting != 'approved',
            }"
          ></div>
          <p class="title"><span>03.</span> Final Underwriting</p>

          <template
            v-if="
              user.phase == 'Final Underwriting' && !user.final_underwriting
            "
          >
            <div class="progress-bar">
              <div class="progress" :style="{ width: progress + '%' }"></div>
            </div>
            <div class="progress-label" :style="{ width: progress + '%' }">
              <p>{{ progress }}%</p>
            </div>
          </template>

          <p>
            Here we'll gather your basic information so we can determine if
            you're a right fit for an Equfi loan.
          </p>

          <div class="complete" v-if="user.final_underwriting == 'approved'">
            <img src="@/assets/img/tick.svg" />
          </div>

          <div
            class="btn-text"
            v-if="
              user.phase == 'Final Underwriting' &&
                user.final_underwriting == 'review'
            "
          >
            <button class="btn text-btn">Documents under review...</button>
            <p>You will be notified when your documents are approved.</p>
          </div>

          <div
            class="btns right"
            v-if="
              !user.final_underwriting && user.phase == 'Final Underwriting'
            "
          >
            <button @click="goTo('/finalunderwriting')" class="btn">
              {{
                $store.state.application_approval_step > 1
                  ? "Continue"
                  : "Get Started"
              }}
            </button>
          </div>
        </div>

        <div class="step">
          <div
            :class="{
              on: user.final_underwriting != 'approved',
            }"
          ></div>
          <p class="title"><span>04.</span> Funding Gate</p>

          <template v-if="user.phase == 'Funding Gate' && !user.funding_gate">
            <div class="progress-bar">
              <div class="progress" :style="{ width: progress + '%' }"></div>
            </div>
            <div class="progress-label" :style="{ width: progress + '%' }">
              <p>{{ progress }}%</p>
            </div>
          </template>

          <p>
            Here we'll gather your basic information so we can determine if
            you're a right fit for an Equfi loan.
          </p>

          <div class="complete" v-if="user.funding_gate == 'approved'">
            <img src="@/assets/img/tick.svg" />
          </div>

          <div
            class="btn-text"
            v-if="
              user.phase == 'Funding Gate' && user.funding_gate == 'waiting'
            "
          >
            <button class="btn text-btn">
              We're determining your funding...
            </button>
            <p>You will be notified when your funding request is ready.</p>
          </div>

          <div
            class="btns right"
            v-if="user.funding_gate == 'pending_approval'"
          >
            <button @click="goTo('/funding')" class="btn">
              View Funding
            </button>
          </div>
          <div class="btns right" v-if="user.funding_gate == 'approved'">
            <button class="btn text-btn">Approved</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";

export default {
  name: "dashboard",
  data() {
    return {
      user: this.$store.state.user,
      progress: this.$store.state.progress,
    };
  },
  firestore() {
    return {
      data: db.collection("user").doc(this.$store.state.user_id),
    };
  },
  created() {
    if (!this.user) {
      this.goTo("/");
    }
    db.collection("user")
      .doc(this.$store.state.user_id)
      .get()
      .then((doc) => {
        this.user = doc.data();
        this.user.id = doc.id;
        if (this.$store.state.user.progress)
          this.user.progress = this.$store.state.user.progress;
        this.$store.commit("setUser", this.user);
      });
  },
  updated() {},
  methods: {
    startSoftUnderwriting() {
      if (this.$store.state.application_approval_step < 2)
        this.$store.commit("setSoftUnderwritingPhase", "start");
      this.goTo("/softunderwriting");
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  .contain {
    max-width: 650px;
    .hello {
      margin-bottom: 10px;
    }
    .steps {
      display: flex;
      flex-direction: column;
      margin-top: 50px;
      .step {
        width: 100%;
        background: white;
        margin-bottom: 20px;
        padding: 30px;
        padding-bottom: 20px;
        border: 1px solid #eaeaea;
        position: relative;
        .disabled {
          background: black;
        }
        .complete {
          position: absolute;
          justify-content: flex-end;
          right: 0;
          top: 0;
          width: auto;
          transform: translateX(50%) translateY(-50%);
          img {
            height: 30px;
          }
        }
        .on {
          position: absolute;
          z-index: 10;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: rgba(255, 255, 255, 0.65);
        }
        p {
          font-size: 15px;
        }
        .title {
          margin-top: 0;
          font-size: 20px;
          font-weight: bold;
          span {
            color: #2d6efb;
          }
        }
        .btn-text {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          background: rgba(11, 110, 251, 0.15);
          text-align: left;
          padding: 20px;
          .btn {
            padding: 0;
            text-align: left;
            cursor: initial;
          }
          p {
            margin-bottom: 0;
            margin-top: 5px;
          }
        }
        .btn {
          font-size: 14px;
          padding: 10px 20px;
        }

        .progress-bar {
          background: rgba(8, 91, 209, 0.1);
          border-radius: 10px;
          height: 7px;
          width: 100%;
          margin: auto;
          display: flex;
          justify-content: flex-start;
          position: relative;
          overflow: hidden;
          margin-bottom: 35px;
          .progress {
            background-color: #0b6efb;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            transition: width 0.5s;
          }
        }

        .progress-label {
          position: absolute;
          left: 5px;
          width: 100%;
          text-align: right;
          padding: 0 20px;
          margin-top: -35px;
          p {
            margin: 0;
            opacity: 0.5;
            font-size: 13px;
            margin-top: 3px;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
